import ClinicScheduleEdit from './ClinicScheduleEdit.vue'
import ClinicScheduleHistory from './ClinicScheduleHistory.vue'
import { executionStatusClass, executionStatusKey } from '@/utils/schedule-execution'

export default {
  name: 'ClinicSchedulesTab',
  props: ['clinic_id'],
  components: {
    ClinicScheduleEdit,
    ClinicScheduleHistory,
  },
  data: () => ({
    loading: false,
    schedules: [],
    tableSchedules: null,
    isEdit: false,
    isHistory: false,
    selectedSchedule: null,
    triggerEnabled: process.env.VUE_APP_SCHEDULE_TRIGGER_ENABLED === 'true',
    triggeringUuid: null,
  }),
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData: async function() {
      this.loading = true
      NProgress.start()
      try {
        let response = await this.$clinicService.listSchedules({clinicId: this.clinic_id})
        this.schedules = response.result ? response.result : []
        const columns = [
          {name: this.$i18n.t('schedule.name'), type: 'string', value: 'name', width: '20%'},
          {name: this.$i18n.t('schedule.typeCol'), type: 'custom', key: 'type', width: '13%'},
          {name: this.$i18n.t('schedule.frequencyCol'), type: 'custom', key: 'frequency', width: '15%'},
          {name: this.$i18n.t('schedule.statusCol'), type: 'custom', key: 'status', width: '11%'},
          {name: this.$i18n.t('schedule.lastExecutionCol'), type: 'custom', key: 'lastExecution', width: '20%'},
          {name: '', type: 'custom', key: 'actions', width: this.triggerEnabled ? '21%' : '12%'},
        ]
        this.tableSchedules = {
          'items': this.schedules,
          'columns': columns
        }
      } catch (err) {
        console.log(err)
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
      }
      NProgress.done(true)
      this.loading = false
    },
    typeLabel(type) {
      const map = {
        report: 'schedule.typeReport',
        claim: 'schedule.typeClaim',
      }
      return map[type] ? this.$i18n.t(map[type]) : type
    },
    periodLabel(item) {
      if (item.notSynced) {
        return this.$i18n.t('schedule.notSyncedShort')
      }
      const map = {
        previousDay: 'schedule.rangePreviousDay',
        previousWeek: 'schedule.rangePreviousWeek',
        previousMonth: 'schedule.rangePreviousMonth',
        last7Days: 'schedule.rangeLast7Days',
        last30Days: 'schedule.rangeLast30Days',
      }
      return map[item.dateRange] ? this.$i18n.t(map[item.dateRange]) : (item.dateRange || '-')
    },
    frequencyLabel(frequency) {
      const map = {
        daily: 'schedule.freqDaily',
        weekly: 'schedule.freqWeekly',
        monthly: 'schedule.freqMonthly',
        custom: 'schedule.freqCustom',
      }
      return map[frequency] ? this.$i18n.t(map[frequency]) : frequency
    },
    lastExecutionClass(item) {
      return executionStatusClass(item.lastExecution.status)
    },
    lastExecutionLabel(item) {
      return this.$i18n.t(executionStatusKey(item.lastExecution))
    },
    lastExecutionDate(item) {
      return moment(item.lastExecution.startedAt).format(this.$i18n.t('dateTimeFormat'))
    },
    toDetails(values) {
      if (!values || !values.item) {
        return
      }
      this.selectedSchedule = values.item
      this.isEdit = true
    },
    newSchedule() {
      this.selectedSchedule = null
      this.isEdit = true
    },
    showHistory(item) {
      if (!item || !item.uuid) {
        return
      }
      this.selectedSchedule = item
      this.isHistory = true
    },
    closeHistory() {
      this.selectedSchedule = null
      this.isHistory = false
    },
    triggerNow: async function(item) {
      if (!item || !item.uuid || this.triggeringUuid) {
        return
      }
      this.triggeringUuid = item.uuid
      NProgress.start()
      try {
        await this.$clinicService.triggerSchedule({clinicId: this.clinic_id, uuid: item.uuid})
        this.$message.popup(this, 'schedule.triggerSuccess', 'operationSuccess', 'success')
      } catch (err) {
        console.log(err)
        this.$message.popup(this, 'schedule.triggerError', 'operationFail', 'error')
      }
      NProgress.done(true)
      this.triggeringUuid = null
      // the run was recorded either way, so refresh the "last execution" column
      await this.fetchData()
    },
    cancelEdit() {
      this.selectedSchedule = null
      this.isEdit = false
    },
    onSaved() {
      this.selectedSchedule = null
      this.isEdit = false
      this.fetchData()
    },
  }
}
